import React, { useEffect, useState } from "react";
import Swiper from "./Components/Swiper";
import CustomForm from "./Components/CustomForm";
import NewsPaper from "./assets/icon/newspaper.png";
import Location from "./assets/icon/location.png";
import Contact from "./assets/icon/contract.png";
import Clipboard from "./assets/icon/clipboard (1).png";
import Bank from "./assets/icon/banknotes.png";
import Invest from "./assets/icon/investment.png";
import Footer from "./Components/Footer";

const data = [
  {
    icon: Clipboard,
    link: "/",
    text: "Урамшууллын эрх шалгах",
  },
  {
    icon: Bank,
    link: "/info",
    text: "100 сая ₮ аяны тухай",
  },
  {
    icon: Invest,
    link: "/savings",
    text: "Хадгаламжийн төрлүүд",
  },
  {
    icon: Contact,
    link: "/form",
    text: "Данс нээлгэх",
  },
  {
    icon: NewsPaper,
    link: "/news",
    text: "Мэдээ",
  },
  {
    icon: Location,
    link: "/locations",
    text: "Салбаруудын байршил",
  },
];

function Home() {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.outerWidth <= 768); // Adjust the breakpoint according to your needs
    };

    handleResize(); // Check initial width
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className={"background"}>
      <Swiper />
      <div className="wrapper">
        <div className="home-title">Урамшуулалт аяны мэдээлэл</div>
        {/*<Tabs />*/}
        <div className="home-container">
          {data.map((e, i) => (
            <a href={e.link} key={i} className="home-item">
              <img src={e.icon} alt="" />
              <div className={"home-item-right"}>{e.text}</div>
            </a>
          ))}
        </div>
        <br />
        <br />
        <div className="home-title">Данс нээх хүсэлт</div>
        <CustomForm />
        <Footer isMobile={isMobile} />
      </div>
    </div>
  );
}

export default Home;
